// extracted by mini-css-extract-plugin
export var compact = "_pt-2";
export var phoneFrame = "_pt-0";
export var phoneScreen = "_pt-1";